/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var InPagNav = function () {
  function InPagNav() {
    _classCallCheck(this, InPagNav);
    this.inPageNavs = document.querySelectorAll('.in-page-nav');
    if (this.inPageNavs.length > 0) {
      this.linkFields = this.getLinkFields();
      this.accordionFields = this.getAccordionFields();
      if (this.accordionFields.length > 0) {
        this.accordions = new Accordion(this.accordionFields, {
          collapse: true,
          duration: 250
        });
      }
      this.links = this.getLinksFromLinkFields();
    }
  }
  return _createClass(InPagNav, [{
    key: "getAccordionFields",
    value: function getAccordionFields() {
      var accordionFields = [];
      this.inPageNavs.forEach(function (nav) {
        accordionFields.push.apply(accordionFields, _toConsumableArray(Array.from(nav.querySelectorAll('.link-group'))));
      });
      return accordionFields;
    }
  }, {
    key: "getLinkFields",
    value: function getLinkFields() {
      var linkFields = [];
      this.inPageNavs.forEach(function (nav) {
        linkFields.push.apply(linkFields, _toConsumableArray(Array.from(nav.querySelectorAll('.field--name-field-link, .field--name-field-links'))));
      });
      return linkFields;
    }
  }, {
    key: "getLinksFromLinkFields",
    value: function getLinksFromLinkFields() {
      var links = [];
      this.linkFields.forEach(function (field) {
        links.push(field.children[0].getAttribute('href'));
      });
      return links;
    }
  }, {
    key: "setCurrentTabAsActive",
    value: function setCurrentTabAsActive() {
      var _this = this;
      if (this.inPageNavs.length > 0) {
        var linkToSearch = window.location.pathname + window.location.search;
        this.links.forEach(function (link, linkIndex) {
          if (link === linkToSearch) {
            _this.linkFields[linkIndex].children[0].classList.add('active');
            _this.setAccordionOpenIfLinkIsInAccordion(_this.linkFields[linkIndex], linkIndex);
          }
        });
      }
    }
  }, {
    key: "setAccordionOpenIfLinkIsInAccordion",
    value: function setAccordionOpenIfLinkIsInAccordion(link) {
      if (link.parentElement.classList.contains('ac-panel') && this.accordions) {
        var accordionIndex = this.accordionFields.indexOf(link.parentElement.parentElement.parentElement);
        this.accordions[accordionIndex].open(accordionIndex);
      }
    }
  }]);
}();
export { InPagNav as default };
(function () {
  var inPagNav = new InPagNav();
  inPagNav.setCurrentTabAsActive();
})(Drupal);